var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProjectSubmission(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon-project-submission",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 13.25C12 13.6641 11.6641 14 11.25 14H0.750001C0.335938 14 0 13.6641 0 13.25V0.750001C0 0.335938 0.335938 0 0.750001 0H7.75001C8.16407 0 8.7422 0.242188 9.03126 0.531251L11.4688 2.96875C11.7578 3.25782 12 3.83594 12 4.25001V13.25ZM1 13H11V5.00001H7.75001C7.33595 5.00001 7.00001 4.66407 7.00001 4.25V1H1V13ZM10.9375 4H8.00001V1.0625C8.13282 1.10938 8.26563 1.17969 8.32032 1.23438L10.7656 3.67969C10.8203 3.73438 10.8906 3.86719 10.9375 4ZM9.00001 6.75001C9.00001 6.89063 8.89064 7.00001 8.75001 7.00001H3.25C3.10938 7.00001 3 6.89063 3 6.75001V6.25001C3 6.10938 3.10938 6.00001 3.25 6.00001H8.75001C8.89064 6.00001 9.00001 6.10938 9.00001 6.25001V6.75001ZM8.75001 9.00001C8.89064 9.00001 9.00001 8.89064 9.00001 8.75001V8.25001C9.00001 8.10938 8.89064 8.00001 8.75001 8.00001H3.25C3.10938 8.00001 3 8.10938 3 8.25001V8.75001C3 8.89064 3.10938 9.00001 3.25 9.00001H8.75001ZM9.00001 10.75C9.00001 10.8906 8.89064 11 8.75001 11H3.25C3.10938 11 3 10.8906 3 10.75V10.25C3 10.1094 3.10938 10 3.25 10H8.75001C8.89064 10 9.00001 10.1094 9.00001 10.25V10.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProjectSubmission);
export default __webpack_public_path__ + "static/media/icon-project-submission.a80a8732b94b1a2aeafc812776f83e44.svg";
export { ForwardRef as ReactComponent };